var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"avatar",style:({
      'width': (_vm.size + "px"),
      'height': (_vm.size + "px"),
    })},[_c('span',{staticClass:"avatar-img",style:({
        'background-image': ("url(" + _vm.picture),'background-size':"contain!important",
        'width': (_vm.size + "px"),
        'height': (_vm.size + "px"),
       })}),(_vm.rank && _vm.rank <4)?_c('span',{class:'avatar-border' + _vm.rank}):_c('span',{staticClass:"avatar-border"}),(_vm.rank)?_c('span',{staticClass:"rank py-1 px-2"},[_vm._v("\n      Rank: "+_vm._s(_vm.rank)+"\n    ")]):_vm._e(),(_vm.reputation)?_c('span',{staticClass:"cruelty py-1 px-2"},[_vm._v("\n      Cruelty: "+_vm._s(_vm.reputation)+"\n    ")]):_c('span',{staticClass:"cruelty py-1 px-2"},[_vm._v("\n      Cruelty: 0\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }